export default class ConversationsApi {
  constructor({ httpGet, httpPost, httpPut, httpDelete }) {
    this.httpGet = httpGet;
    this.httpPost = httpPost;
    this.httpPut = httpPut;
    this.httpDelete = httpDelete;
  }

  pinConversation(conversationId, params, httpConfig) {
    return this.httpPost(`conversations/${conversationId}/pin`, params, httpConfig);
  }

  unpinConversation(conversationId, params, httpConfig) {
    return this.httpDelete(`conversations/${conversationId}/pin`, params, httpConfig);
  }

  archiveConversation(conversationId, params, httpConfig) {
    return this.httpDelete(`conversations/${conversationId}`, params, httpConfig);
  }

  unarchiveConversation(conversationId, params, httpConfig) {
    return this.httpPost(`conversations/${conversationId}/unarchive`, params, httpConfig);
  }

  deleteConversation(conversationId, params, httpConfig) {
    return this.httpDelete(`conversations/${conversationId}`, { action: 'delete' }, httpConfig);
  }
}
